import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Save } from "lucide-react";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { NutritionInfoForm } from "../../components/nutrition/NutritionInfoForm";

export default function MyNutritionInfo() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  useEffect(() => { api.get("/me/nutrition-info").then((r) => setData(r.data.info || {})).catch((e) => toast.error(formatErr(e))); }, []);
  const save = async () => {
    setBusy(true);
    try { await api.put("/me/nutrition-info", { data }); toast.success("¡Gracias! Tu entrenador ya tiene tus horarios."); navigate("/app/mi-planificacion"); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <AppShell>
      <div style={{ maxWidth: 680 }} data-testid="my-nutrition-info-page">
        <h1 style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: "2rem", letterSpacing: "0.06em", margin: 0 }}>Tus horarios y alimentación</h1>
        <p style={{ color: "#a3a3a3", fontSize: 13, margin: "4px 0 18px" }}>Con estos datos tu entrenador prepara tu guía nutricional por horarios. Es orientación deportiva, no una dieta médica.</p>
        {data ? <NutritionInfoForm data={data} setData={setData} testid="my-nutri-info" /> : <div style={{ color: "#a3a3a3" }}>Cargando…</div>}
        {data && <button className="qv-btn-primary" onClick={save} disabled={busy} data-testid="my-nutri-info-save"
          style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "12px 22px" }}><Save size={16} /> {busy ? "Guardando…" : "Guardar"}</button>}
      </div>
    </AppShell>
  );
}
